import { on } from 'delegated-events'

on('click', 'button.plans-mobile-header', e => {
  const button = e.currentTarget
  button.parentNode?.classList?.toggle('plans-mobile-table__expanded')
})
